module.exports = __webpack_public_path__ + "img/DSC_0011.07a2fcf1.jpg";